module.exports = __webpack_public_path__ + "static/logo-56317699d6e8aa3ba3642ed8ef39b916.png";